import { render, staticRenderFns } from "./eventsResults.vue?vue&type=template&id=4949429c"
import script from "./eventsResults.vue?vue&type=script&lang=js"
export * from "./eventsResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports